import { Injectable, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { fromEvent } from 'rxjs';
import { filter, shareReplay } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class DocumentEventService {
  private readonly doc = inject(DOCUMENT);

  readonly click$ = fromEvent<MouseEvent>(this.doc, 'click').pipe(shareReplay(1));

  readonly escape$ = fromEvent<KeyboardEvent>(this.doc, 'keydown').pipe(
    filter((e) => e.key === 'Escape'),
    shareReplay(1),
  );

  readonly windowScroll$ = fromEvent(this.doc.defaultView ?? window, 'scroll', { passive: true }).pipe(shareReplay(1));
}
